module.exports = __webpack_public_path__ + "static/media/verified.164b04be.svg";